export default __webpack_public_path__ + "static/card-index-middle-2-e8e0a16b189fa5207f36e0577d1d5a2c.jpg";